import { X } from "lucide-react";

const PrivacyPolicyModal = ({ isOpen, onClose }) => {
    if (isOpen !== "privacy") return null;
    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm px-2 sm:px-4">
            <div className="relative bg-white w-full max-w-3xl rounded-2xl shadow-2xl overflow-hidden p-3">
                {/* Header */}
                <div className="flex items-center justify-between bg-gradient-to-r from-[#ECF1FF] to-[#EED8FF] px-5 py-3 rounded-t-lg">
                    <h2 className="font-semibold text-lg sm:text-xl text-[#2C25C4]">
                        Privacy Policy
                    </h2>
                    <button
                        onClick={onClose}
                        className="rounded-full p-1 bg-[#FFFFFF] text-red-500 cursor-pointer"
                    >
                        <X size={20} />
                    </button>
                </div>

                {/* Content */}
                <div className="p-5 max-h-[80vh] overflow-y-auto text-gray-800">
                    <p className="text-sm text-gray-500 mb-4">
                        <strong className="text-primary-200">Effective Date:</strong> 17 September 2025
                    </p>

                    <p className="text-sm text-gray-700 mb-3">
                        <strong className="text-red-500">Disclaimer:</strong> This Privacy Policy is designed to
                        provide clear and helpful information about how CareerConnect
                        manages your personal data. CareerConnect is committed to
                        maintaining accuracy and transparency to support informed decisions
                        by our users. We encourage users to review and manage their personal
                        information responsibly, ensuring a safe and productive experience
                        on our platform.
                    </p>

                    <p className="text-sm text-gray-700 mb-4">
                        CareerConnect AI (“Company,” “we,” “our,” “us”) is committed to
                        safeguarding the privacy of individuals who use our platform,
                        including job seekers and employers. This Privacy Policy explains
                        how we collect, use, disclose, and protect your personal information
                        when you interact with our services.
                    </p>

                    <p className="text-sm text-gray-700 mb-4">
                        By accessing CareerConnect AI, you acknowledge and agree to the
                        practices described in this Privacy Policy.
                    </p>

                    {/* Section 1 */}
                    <h3 className="font-semibold text-blue-700 mt-4 mb-2">1. Scope</h3>
                    <ul className="list-disc list-inside text-sm text-gray-700 space-y-1">
                        <li>
                            Job Seekers who register, create profiles, and apply for jobs.
                        </li>
                        <li>
                            Employers / Recruiters who post jobs, search profiles, and
                            communicate with candidates.
                        </li>
                        <li>Visitors accessing our website or mobile application.</li>
                    </ul>
                    <p className="text-sm mt-2">
                        This Policy does not apply to third-party websites or services
                        linked from CareerConnect AI.
                    </p>

                    {/* Section 4 */}
                    <h3 className="font-semibold text-blue-700 mt-4 mb-2">
                        4. Job Postings & Applications
                    </h3>
                    <p className="text-sm">
                        Employers are responsible for the accuracy of job descriptions.
                        CareerConnect AI is not liable for any hiring decisions, offers, or
                        employment outcomes. Job seekers must apply with truthful
                        information (resume, profile, etc.).
                    </p>

                    {/* Section 5 */}
                    <h3 className="font-semibold text-blue-700 mt-4 mb-2">
                        5. Prohibited Activities
                    </h3>
                    <p className="text-sm">
                        Users are strictly prohibited from: Posting fake jobs or resumes.
                        Using the platform for spam, scams, or fraudulent activity. Sharing
                        obscene, offensive, or illegal content. Violating any applicable law
                        or regulation.
                    </p>

                    {/* Section 6 */}
                    <h3 className="font-semibold text-blue-700 mt-4 mb-2">
                        6. Intellectual Property
                    </h3>
                    <p className="text-sm">
                        All content, design, logos, and features of CareerConnect AI are
                        owned by us. Users may not copy, reproduce, or distribute without
                        written consent.
                    </p>

                    {/* Section 7 */}
                    <h3 className="font-semibold text-blue-700 mt-4 mb-2">7. Privacy</h3>
                    <p className="text-sm">
                        We respect your privacy. Data collected will be used as per our
                        Privacy Policy. By using the platform, you consent to such use.
                    </p>

                    {/* Section 8 */}
                    <h3 className="font-semibold text-blue-700 mt-4 mb-2">
                        8. Limitation of Liability
                    </h3>
                    <p className="text-sm">
                        CareerConnect AI is a connection platform. We are not responsible
                        for guaranteeing job placement, employer conduct or authenticity, or
                        accuracy of user-provided information. Users use the platform at
                        their own risk.
                    </p>

                    {/* Section 9 */}
                    <h3 className="font-semibold text-blue-700 mt-4 mb-2">
                        9. Termination of Account
                    </h3>
                    <p className="text-sm">
                        We reserve the right to suspend or terminate accounts if false or
                        fraudulent information is detected, misuse, spam, or harmful
                        activity is reported, or if any violation of these Terms occurs.
                    </p>

                    {/* Section 10 */}
                    <h3 className="font-semibold text-blue-700 mt-4 mb-2">
                        10. Changes to Terms
                    </h3>
                    <p className="text-sm">
                        We may update these Terms & Conditions at any time. Continued use of
                        the platform means acceptance of the revised terms.
                    </p>

                    {/* Section 11 */}
                    <h3 className="font-semibold text-blue-700 mt-4 mb-2">
                        11. Governing Law
                    </h3>
                    <p className="text-sm">
                        These Terms & Conditions will be governed by and interpreted under
                        the laws of the Indian Govt.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default PrivacyPolicyModal;
